import styled from 'styled-components';

import { colors, spacing } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';

export const TableCell = styled.div`
  align-items: center;
  color: ${colors.textPrimary};
  display: flex;
  justify-content: flex-start;
  /** the data feed URLs can get ENORMOUS and don't have standard characters to wrap */
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const MinHeightSkeleton = styled(Skeleton)`
  min-height: ${spacing.doubleHalf};
`;

export const RedText = styled.span`
  color: ${colors.textDestructive};
`;
